import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledToggleButton = styled.button<{ isSelected?: boolean }>`
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  border-radius: 6px;
  background-color: ${({ isSelected }) => (isSelected ? colorsPalettes.bluegrey[100] : colorsPalettes.carbon[0])};
  padding: 8px 12px 8px 12px;
  ${({ isSelected }) =>
    setFontVariant('sectionTitle', isSelected ? colorsPalettes.blue[400] : colorsPalettes.midnight[200])};
  letter-spacing: 0.6px;
  font-weight: 500;
  line-height: 16px;
  border: ${({ isSelected }) => (isSelected ? `1px solid ${colorsPalettes.blue[400]}` : '1px solid #e6e9ec')};
  cursor: pointer;
  transition:
    background-color 0.2s ease-in-out,
    color 0.2s ease-in-out,
    border-color 0.2s ease-in-out;

  &:hover,
  &:active {
    background-color: ${colorsPalettes.bluegrey[100]};
    color: ${colorsPalettes.blue[400]};
  }
`;

export const StyledToggleIconWrapper = styled.div<{ isSelected?: boolean }>`
  width: ${({ isSelected }) => (isSelected ? '9px' : 0)};
  transition: width 0.2s ease-in-out;
`;
